var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_2846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.254 0.910156L5.43403 2.89016C4.00403 3.15016 2.81403 4.15016 2.31403 5.52016L0.364032 10.8202C0.314032 10.9402 0.304032 11.0702 0.314032 11.2102L0.874032 18.1402C0.914032 18.6102 1.30403 18.9702 1.77403 18.9702C2.27403 18.9702 2.68403 19.3702 2.67403 19.8702C2.67403 21.1902 2.65403 23.6202 2.61403 24.8702C2.60403 25.2402 2.81403 25.5702 3.15403 25.7202C4.87403 26.4602 10.224 28.5602 15.124 28.4902C20.064 28.4102 27.264 25.8202 29.574 24.9402C30.004 24.7802 30.234 24.3302 30.124 23.8902C29.404 20.9902 27.014 10.6302 28.364 6.26016C28.384 6.20016 28.394 6.13016 28.394 6.07016V5.83016C28.354 4.69016 27.604 3.69016 26.514 3.34016L19.634 1.13016C18.494 1.06016 17.394 0.990156 16.254 0.910156Z",
    fill: "url(#paint0_linear_3235_2846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5256 9.53069L29.2956 9.20069C29.3956 9.18069 29.4856 9.25069 29.4956 9.35069L29.2956 15.2507C29.2956 15.3107 29.2656 15.3707 29.2156 15.4007L27.9156 16.1607C27.9156 16.1607 27.8256 16.1907 27.7756 16.1707L26.1256 15.5907C26.0556 15.5707 26.0156 15.5007 26.0156 15.4307L26.3856 9.69069C26.3856 9.62069 26.4456 9.56069 26.5156 9.54069L26.5256 9.53069Z",
    fill: "url(#paint1_linear_3235_2846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81375 9.62053L2.04375 9.29053C1.94375 9.27053 1.85375 9.34053 1.84375 9.44053L2.04375 15.3405C2.04375 15.4005 2.07375 15.4605 2.12375 15.4905L3.42375 16.2505C3.42375 16.2505 3.51375 16.2805 3.56375 16.2605L5.21375 15.6805C5.28375 15.6605 5.32375 15.5905 5.32375 15.5205L4.95375 9.78053C4.95375 9.71053 4.89375 9.65053 4.82375 9.63053L4.81375 9.62053Z",
    fill: "url(#paint2_linear_3235_2846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5738 7.31055H5.42383C4.73383 7.31055 4.17383 7.87055 4.17383 8.56055V16.3005C4.17383 18.7805 5.55383 21.0505 7.76383 22.1905L12.5338 24.6505C14.4438 25.6405 16.7138 25.6405 18.6238 24.6505L23.3938 22.1905C25.5938 21.0505 26.9838 18.7805 26.9838 16.3005V8.56055C26.9838 7.87055 26.4238 7.31055 25.7338 7.31055H15.5838H15.5738Z",
    fill: "url(#paint3_linear_3235_2846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29492 6.93047C3.29492 6.93047 3.68492 17.2005 4.17492 17.2505L5.31492 17.0505C5.31492 17.0505 4.56492 9.33047 4.66492 8.59047L4.30492 10.2005L6.91492 10.4005L7.59492 6.93047V12.5505L9.74492 12.7805L11.0149 4.88047L10.7249 9.67047H16.1049V8.99047L16.4849 9.73047L21.6549 9.64047L21.8349 8.99047L22.0749 9.58047H24.3249V7.04047L26.6849 7.60047L26.8049 9.76047V10.6805L27.3649 10.5905L27.2449 4.62047L11.0549 3.23047L3.30492 6.94047L3.29492 6.93047Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8645 12.9395C22.1045 13.1595 22.2545 13.4695 22.2545 13.8195C22.2545 14.4895 21.7145 15.0295 21.0445 15.0295C20.3745 15.0295 19.8345 14.4895 19.8345 13.8195C19.8345 13.6995 19.8545 13.5895 19.8845 13.4895C18.6345 14.3095 17.8945 15.8695 17.8945 15.8695C17.8945 15.8695 21.6345 16.3795 22.9345 15.5495C24.2345 14.7195 25.5045 13.4195 25.5045 13.4195C25.5045 13.4195 23.5345 12.8995 21.8645 12.9495V12.9395Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0437 15.0197C21.7137 15.0197 22.2537 14.4797 22.2537 13.8097C22.2537 13.4597 22.1037 13.1497 21.8637 12.9297C21.4437 12.9397 21.0337 12.9897 20.6937 13.0897C20.4037 13.1697 20.1437 13.3097 19.8937 13.4697C19.8637 13.5797 19.8438 13.6897 19.8438 13.7997C19.8438 14.4697 20.3837 15.0097 21.0537 15.0097L21.0437 15.0197Z",
    fill: "#3E424A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6845 13.2907C22.1845 12.8507 24.7145 13.4007 25.3445 13.5607C25.4345 13.4707 25.4945 13.4107 25.4945 13.4107C25.4945 13.4107 22.4145 12.5907 20.6845 13.1007C18.9545 13.6107 17.8945 15.8607 17.8945 15.8607C17.8945 15.8607 17.9245 15.8607 17.9845 15.8707C18.2745 15.3307 19.2445 13.7107 20.6845 13.2807V13.2907Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2548 17.1309C14.7748 17.2409 15.8848 17.4209 16.8448 17.1909C16.9548 17.1609 17.0248 17.2909 16.9448 17.3709C16.5648 17.7509 15.9148 18.3609 15.6048 18.4709C15.2648 18.5909 14.5048 17.7409 14.1548 17.3109C14.0948 17.2309 14.1548 17.1209 14.2548 17.1409V17.1309Z",
    fill: "url(#paint4_linear_3235_2846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5449 20.0095C15.5449 20.0095 16.7749 20.2195 17.5849 19.2695",
    stroke: "#E98E8A",
    strokeWidth: 0.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3948 11.5098L18.1348 12.5598L23.1948 12.2998L24.8548 12.5598V12.0798L18.3948 11.5098Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2943 12.9395C9.0543 13.1595 8.9043 13.4695 8.9043 13.8195C8.9043 14.4895 9.4443 15.0295 10.1143 15.0295C10.7843 15.0295 11.3243 14.4895 11.3243 13.8195C11.3243 13.6995 11.3043 13.5895 11.2743 13.4895C12.5243 14.3095 13.2643 15.8695 13.2643 15.8695C13.2643 15.8695 9.5243 16.3795 8.2243 15.5495C6.9243 14.7195 5.6543 13.4195 5.6543 13.4195C5.6543 13.4195 7.6243 12.8995 9.2943 12.9495V12.9395Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1143 15.0197C9.4443 15.0197 8.9043 14.4797 8.9043 13.8097C8.9043 13.4597 9.0543 13.1497 9.2943 12.9297C9.7143 12.9397 10.1243 12.9897 10.4643 13.0897C10.7543 13.1697 11.0143 13.3097 11.2643 13.4697C11.2943 13.5797 11.3143 13.6897 11.3143 13.7997C11.3143 14.4697 10.7743 15.0097 10.1043 15.0097L10.1143 15.0197Z",
    fill: "#3E424A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4643 13.2907C8.9643 12.8507 6.4343 13.4007 5.8043 13.5607C5.7143 13.4707 5.6543 13.4107 5.6543 13.4107C5.6543 13.4107 8.7343 12.5907 10.4643 13.1007C12.1943 13.6107 13.2543 15.8607 13.2543 15.8607C13.2543 15.8607 13.2243 15.8607 13.1643 15.8707C12.8743 15.3307 11.9043 13.7107 10.4643 13.2807V13.2907Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7549 11.5098L13.0149 12.5598L7.95492 12.2998L6.29492 12.5598V12.0798L12.7549 11.5098Z",
    fill: "#2A2A41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_2846",
    x1: 15.424,
    y1: 26.6302,
    x2: 14.994,
    y2: 7.03016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3B3B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#333355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2E2E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2A2A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2A41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3235_2846",
    x1: 27.8656,
    y1: 9.06069,
    x2: 27.6056,
    y2: 16.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3235_2846",
    x1: 3.42375,
    y1: 9.02053,
    x2: 3.74375,
    y2: 16.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3235_2846",
    x1: 15.5738,
    y1: 6.85055,
    x2: 15.5738,
    y2: 21.9105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3235_2846",
    x1: 15.5348,
    y1: 17.7009,
    x2: 15.5148,
    y2: 19.2609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C18988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_2846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.85,
    height: 27.58,
    fill: "white",
    transform: "translate(0.304688 0.910156)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHead);
export default __webpack_public_path__ + "static/media/blue_head.a9e52998ddc7648a85a23e80620e66b9.svg";
export { ForwardRef as ReactComponent };